import React, { useState, useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';
import axios from '../utils/api';
import AdminHome from '../components/AdminHome';
import UserManagement from '../components/UserManagement';
import PdfManagement from '../components/PdfManagement';

const AdminDashboard = () => {
  const { user, isAdmin } = useAuth();
  const navigate = useNavigate();
  
  const [currentView, setCurrentView] = useState('home');
  const [users, setUsers] = useState([]);
  const [pdfs, setPdfs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!user || !isAdmin()) {
      navigate('/login', { replace: true });
      return;
    }
    
    loadInitialData();
  }, [user, isAdmin, navigate]);

  const loadInitialData = async () => {
    try {
      const [usersResponse, pdfsResponse] = await Promise.all([
        axios.get('/api/auth/admin/users'),
        axios.get('/api/pdf/admin/all')
      ]);
      
      setUsers(usersResponse.data);
      setPdfs(pdfsResponse.data);
    } catch (error) {
      console.error('Error loading initial data:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleNavigate = (view) => {
    setCurrentView(view);
  };

  const handleBackToHome = () => {
    setCurrentView('home');
    // Reload data when returning to home
    loadInitialData();
  };

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '100vh' }}>
        <div className="text-center">
          <div className="spinner-border text-primary" role="status" style={{ width: '3rem', height: '3rem' }}>
            <span className="visually-hidden">Carregando...</span>
          </div>
          <p className="mt-3 text-muted">Carregando painel administrativo...</p>
        </div>
      </div>
    );
  }

  // Render different views based on currentView state
  switch (currentView) {
    case 'users':
      return <UserManagement onBack={handleBackToHome} />;
    case 'pdfs':
      return <PdfManagement onBack={handleBackToHome} />;
    default:
      return (
        <AdminHome
          onNavigate={handleNavigate}
          user={user}
          usersCount={users.length}
          pdfsCount={pdfs.length}
        />
      );
  }
};

export default AdminDashboard;